export const GET_ADVERTISE = "admin/advertisement";

export const POST_ADVERTISE = "admin/advertisement";

export const ACTION_ADVERTISE = "admin/advertisement/disable";

export const DELETE_ADVERTISE = "admin/advertisement";
